<div
  class="absolute top-0 right-0 bottom-0 left-0 z-1000 py-16"
  [ngClass]="isLoading() ? 'bg-black/30' : 'pointer-events-none'">
  <div class="relative mx-auto h-full w-fit">
    @for (toast of toasts(); track $index) {
      <shared-core-toast
        class="absolute bottom-0 transition-all"
        [style.transform]="'translateY(' + -$index * 110 + '%)'"
        [toastConfig]="toast"
        (closeToast)="removeToast(toast.id)" />
    }
  </div>
</div>
